var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSmsFeatureAblaufgrafikDesktopStep3Rgb = function SvgSmsFeatureAblaufgrafikDesktopStep3Rgb(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 300 180",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "schrift"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.9,174H198v-4.5c0-14.2-9.9-25.8-22.1-25.8h-.5c-2.6-16-14.6-28.1-29-28.1a24.7,24.7,0,0,0-8.6,1.5c-6.7-15.4-20.4-25.9-36.2-25.9s-29,10.2-35.8,25.2a24.8,24.8,0,0,0-6.1-.7c-14.5,0-26.6,12.3-29.1,28.4a22,22,0,0,0-3.6-.4c-12.2,0-22.1,11.5-22.1,25.8V174Z",
    style: {
      fill: "var(--ca-primary-color-lightest, #96e3fa)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1,174H265.5v-3.7a22.1,22.1,0,0,0-22.1-22.1h-.5a29.6,29.6,0,0,0-29.1-24.1,27.1,27.1,0,0,0-8.6,1.3,40.6,40.6,0,0,0-72.1-.6,30.8,30.8,0,0,0-6.1-.6,29.5,29.5,0,0,0-29.1,24.4l-3.6-.3a22.1,22.1,0,0,0-22.1,22.1V174Z",
    style: {
      fill: "var(--ca-primary-color-lighter, #5fcced)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.5,174H296.1v-2.8c0-8.9-7.9-16-17.6-16h-.4c-2-9.9-11.6-17.5-23.1-17.5a24.8,24.8,0,0,0-6.8.9c-5.3-9.6-16.2-16.1-28.8-16.1s-23.1,6.3-28.5,15.6a26.1,26.1,0,0,0-4.8-.5c-11.6,0-21.2,7.6-23.1,17.7l-2.9-.2c-9.7,0-17.6,7.2-17.6,16V174Z",
    style: {
      fill: "var(--ca-primary-color-lightest, #96e3fa)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "schrift-2",
    "data-name": "schrift"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M67.4,10.1h2.3l2,5.7.8,2.3h.1l.7-2.3,2.1-5.7h2.3V21.8H75.8V16.4c0-1,.1-2.6.2-3.7h-.1L75,15.4l-1.9,5.2H71.8l-1.9-5.2L69,12.7h-.1c.1,1.1.2,2.7.2,3.7v5.4H67.2l.2-11.7Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6,10.1h2V21.8h-2Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88,11.9H84.7V10.1h8.7v1.8H90.1v9.9h-2V11.9Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3,15.9c0-3.8,2.4-6.1,5.3-6.1a4.3,4.3,0,0,1,3.3,1.5l-1.1,1.3a3.2,3.2,0,0,0-2.2-1c-1.9,0-3.3,1.6-3.3,4.2s1.3,4.3,3.2,4.3A3.8,3.8,0,0,0,106,19l1.2,1.2a4.4,4.4,0,0,1-3.7,1.7C100.7,21.9,98.3,19.9,98.3,15.9Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.9,15.9c0-3.8,2.2-6,5.1-6s5.1,2.3,5.1,6S115.9,22,113,22,107.9,19.6,107.9,15.9Zm8.3,0c0-2.7-1.1-4.2-3-4.2s-3.1,1.5-3.1,4.2,1.1,4.3,3.1,4.3S116.2,18.5,116.2,15.9Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.7,10.1h3c3.6,0,5.7,1.9,5.7,5.7s-2.1,5.8-5.6,5.8h-3.1Zm2.9,10c2.3,0,3.7-1.3,3.7-4.2s-1.4-4-3.7-4h-.9v8.2Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.7,10.1h7v1.8h-4.9v2.9H138v1.8h-4.2V20h5v1.8h-7.1Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.1,10.1h2.4l3.8,11.7h-2.1l-1.8-6.3a23.6,23.6,0,0,1-1-3.8h-.1c-.4,1.3-.7,2.7-1.1,3.8l-1.7,6.3h-2.2Zm-1.5,6.8H151v1.7h-5.4Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.7,10.1h3.7c2.4,0,4.2.7,4.2,2.9a2.5,2.5,0,0,1-1.6,2.5v.2a2.7,2.7,0,0,1,2.3,2.8c0,2.3-1.9,3.4-4.5,3.4h-4.1Zm3.6,4.8c1.7,0,2.3-.6,2.3-1.7s-.8-1.5-2.3-1.5h-1.5v3.2Zm.3,5.2c1.6,0,2.6-.6,2.6-1.9s-.9-1.8-2.6-1.8h-1.8v3.7Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.3,20.2l1.1-1.4a4.6,4.6,0,0,0,3.1,1.3c1.2,0,2-.6,2-1.5s-.8-1.3-1.8-1.7l-1.6-.6a3.4,3.4,0,0,1-2.4-3.1c0-1.9,1.6-3.3,3.9-3.3a4.8,4.8,0,0,1,3.6,1.6l-1.1,1.2a3.7,3.7,0,0,0-2.5-1c-1.1,0-1.8.5-1.8,1.4s.9,1.3,1.9,1.7l1.6.6c1.4.6,2.4,1.4,2.4,3.2s-1.6,3.4-4.2,3.4A5.6,5.6,0,0,1,164.3,20.2Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.7,11.9h-3.3V10.1h8.8v1.8h-3.4v9.9h-2.1Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.1,10.1h2.1V21.8h-2.1Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.1,10.1h2.3l2,5.7.8,2.3h.1a20.9,20.9,0,0,1,.8-2.3l2-5.7h2.3V21.8h-1.9V16.4c0-1,.1-2.6.2-3.7h-.1l-.9,2.7-1.9,5.2h-1.3l-1.9-5.2-.9-2.7h-.1c.1,1.1.3,2.7.3,3.7v5.4h-2l.2-11.7Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.4,10.1h2.3l2.1,5.7c.2.8.5,1.5.7,2.3h.1a20.9,20.9,0,0,0,.8-2.3l2-5.7h2.3V21.8h-1.9V16.4c0-1,.2-2.6.3-3.7H211l-.9,2.7-1.9,5.2h-1.3L205,15.4l-.9-2.7H204c.1,1.1.2,2.7.2,3.7v5.4h-1.9V10.1Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.7,10.1h7v1.8h-5v2.9h4.2v1.8h-4.2V20h5.1v1.8h-7.1Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.2,10.1h2.2l3.5,6.5,1.2,2.5h.1c-.1-1.1-.3-2.7-.3-3.9V10.1h1.9V21.8h-2.1l-3.6-6.6L227,12.7h-.2a26.9,26.9,0,0,1,.3,4v5.1h-1.9Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.8,64.7a7.6,7.6,0,0,0-.5-2.6,9.3,9.3,0,0,0-2.6-3.9c-.4-.3-3.6-3.1-7.7-2.2a8.1,8.1,0,0,0-4.5,2.3c-5.2,4.9-2,11.6-2,11.6l-10.9,9.2c-.3.3.2.7.2.7l1.3,1.7a1.1,1.1,0,0,0,1,.1l1.6-1.3,8.8-7.6a11.3,11.3,0,0,0,4.1,2.2,9.7,9.7,0,0,0,7-1.2A10.3,10.3,0,0,0,149.8,64.7ZM140,73.1c-4.2-.4-6.7-4.3-6.4-8.5s4-7.4,7.9-6.9a7.6,7.6,0,0,1,6.3,8.5C147.4,70.4,143.9,73.6,140,73.1Z",
    style: {
      fill: "#6fdafb"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M119.4,113h-5.8v-1.8h5.8Zm-10.8,0h-6.1v-1.8h6.1Zm-11.1,0H91.4v-1.8h6.1Zm-11.1,0H80.3v-1.8h6.1Zm-11.1,0h-6v-1.8h6Zm-11,0H58.2v-1.8h6.1Zm-11.1,0H47.1v-1.8h6.1Zm-11.1,0h-6v-1.8h6Zm-11,0H25v-1.8h6.1Z",
    style: {
      fill: "var(--ca-primary-color-base, #009dd4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.3,108h-5.9v-1.8h5.9Zm-10.9,0h-6.1v-1.8h6.1Zm-11.1,0H91.2v-1.8h6.1Zm-11.1,0h-6v-1.8h6Zm-11,0H69.1v-1.8h6.1Zm-11.1,0H58v-1.8h6.1ZM53,108H47v-1.8h6Z",
    style: {
      fill: "var(--ca-primary-color-base, #009dd4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.1,118.4h-5.7v-1.8h5.7Zm-10.7,0h-6.1v-1.8h6.1Zm-11.1,0h-6v-1.8h6Zm-11,0H80.2v-1.8h6.1Zm-11.1,0H69.1v-1.8h6.1Zm-11.1,0h-6v-1.8h6Zm-11,0H47v-1.8h6.1Zm-11.1,0H35.9v-1.8H42Zm-11.1,0h-6v-1.8h6Zm-11,0H13.8v-1.8h6.1Zm-11.1,0H2.7v-1.8H8.8Z",
    style: {
      fill: "var(--ca-primary-color-base, #009dd4)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M177.4,111.2h5.9V113h-5.9Zm10.9,0h6V113h-6Zm11,0h6.1V113h-6.1Zm11.1,0h6.1V113h-6.1Zm11.1,0h6V113h-6Zm11,0h6.1V113h-6.1Zm11.1,0h6.1V113h-6.1Zm11.1,0h6.1V113h-6.1Zm11.1,0h6V113h-6Z",
    style: {
      fill: "var(--ca-primary-color-base, #009dd4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.5,106.3h5.9v1.8h-5.9Zm10.9,0h6.1v1.8h-6.1Zm11.1,0h6.1v1.8h-6.1Zm11.1,0h6v1.8h-6Zm11,0h6.1v1.8h-6.1Zm11.1,0h6.1v1.8h-6.1Zm11.1,0h6.1v1.8h-6.1Z",
    style: {
      fill: "var(--ca-primary-color-base, #009dd4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.7,116.6h5.7v1.8h-5.7Zm10.7,0h6.1v1.8h-6.1Zm11.1,0h6.1v1.8h-6.1Zm11.1,0h6v1.8h-6Zm11,0h6.1v1.8h-6.1Zm11.1,0h6.1v1.8h-6.1Zm11.1,0h6v1.8h-6Zm11,0h6.1v1.8h-6.1Zm11.1,0H272v1.8h-6.1Zm11.1,0h6v1.8h-6Zm11,0h6.1v1.8H288Z",
    style: {
      fill: "var(--ca-primary-color-base, #009dd4)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_5",
    "data-name": "Ebene 5"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 68.7,
    y: 37.6,
    width: 160.3,
    height: 124.95,
    rx: 8.5,
    style: {
      fill: "#fff",
      stroke: "var(--ca-primary-color-base, #009dd4)",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.2,44.3a2.1,2.1,0,1,0,2,2.1A2.1,2.1,0,0,0,206.2,44.3Z",
    style: {
      fill: "var(--ca-primary-color-base, #009dd4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.1,44.3a2.1,2.1,0,1,0,2,2.1A2.1,2.1,0,0,0,212.1,44.3Z",
    style: {
      fill: "var(--ca-primary-color-base, #009dd4)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 218,
    cy: 46.4,
    r: 2,
    style: {
      fill: "var(--ca-primary-color-base, #009dd4)"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 68.9,
    y1: 53,
    x2: 228.5,
    y2: 53,
    style: {
      fill: "none",
      stroke: "var(--ca-primary-color-base, #009dd4)",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 81.7,
    y: 69.8,
    width: 139.4,
    height: 31.39,
    style: {
      fill: "var(--ca-primary-color-lightest, #96e3fa)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.8,
    y: 127.5,
    width: 63.7,
    height: 10.49,
    style: {
      fill: "#fff",
      stroke: "var(--ca-primary-color-base, #009dd4)",
      strokeMiterlimit: 10,
      strokeWidth: "0.75px",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.6,153.1H82.9a1.5,1.5,0,0,1-1.5-1.5v-7.1a1.5,1.5,0,0,1,1.5-1.5h59.7a1.4,1.4,0,0,1,1.4,1.5v7.1A1.3,1.3,0,0,1,142.6,153.1Z",
    style: {
      fill: "var(--ca-primary-color-base, #009dd4)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155.6,
    y: 103.8,
    width: 64.9,
    height: 34.38,
    style: {
      fill: "var(--ca-primary-color-lightest, #96e3fa)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.5,
    y: 58.7,
    width: 139.6,
    height: 7.15,
    style: {
      fill: "var(--ca-primary-color-lightest, #96e3fa)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.1,
    y: 109.6,
    width: 26.6,
    height: 5.63,
    style: {
      fill: "var(--ca-primary-color-lightest, #96e3fa)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.1,80a5.7,5.7,0,0,0-.5-2.6,9.3,9.3,0,0,0-2.6-3.9c-.4-.3-3.5-3.1-7.7-2.2a8.8,8.8,0,0,0-4.4,2.4c-5.2,4.9-2.1,11.5-2.1,11.5L88,94.5c-.3.2.1.7.1.7l1.3,1.6a1,1,0,0,0,1.1.1L92,95.6l8.9-7.6a10.4,10.4,0,0,0,4,2.2A10,10,0,0,0,112,89,10.2,10.2,0,0,0,116.1,80Zm-9.8,8.5c-4.1-.5-6.6-4.4-6.4-8.6s4-7.4,7.9-6.9a7.7,7.7,0,0,1,6.4,8.5C113.7,85.7,110.2,88.9,106.3,88.5Z",
    style: {
      fill: "#93e3fc"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M87,129.1h2.2l2.2,6.9h-2l-.3-1.5h-2l-.3,1.5h-2Zm.4,4h1.3v-.5c-.2-.6-.3-1.5-.5-2.2H88c-.1.7-.3,1.6-.4,2.2Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5,135.2l.8-1.2a2.4,2.4,0,0,0,1.4.6c.6,0,1-.2,1-.6s-.2-.8-1.7-.8v-1.3c1.2,0,1.5-.3,1.5-.7s-.2-.7-.7-.7a1.6,1.6,0,0,0-1.2.6l-.9-1.1a2.9,2.9,0,0,1,2.2-.9c1.5,0,2.5.7,2.5,1.9a1.6,1.6,0,0,1-1.1,1.5h0a1.6,1.6,0,0,1,1.3,1.6c0,1.3-1.2,2-2.7,2A3,3,0,0,1,91.5,135.2Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9,129.1h4.5v1.5H99.8v1.1H102v1.5H99.8v1.3h2.7V136H97.9Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.1,132.4l-1.8-3.3h2.1l.5,1.1.5,1.1h0a11.7,11.7,0,0,1,.5-1.1l.4-1.1h2l-1.8,3.4,1.9,3.5h-2.1l-.6-1.2a6.1,6.1,0,0,0-.5-1.2h0l-.5,1.2-.5,1.2h-2Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.6,134.5h-2.9v-1.3l2.3-4h2.4v3.9h.7v1.4h-.7V136h-1.8Zm0-1.4v-.8c0-.4.1-1.1.1-1.6h-.1a6.1,6.1,0,0,1-.5,1.2l-.6,1.2Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.7,130.8h-2.9v-1.6h4.9v1.2c-1.6,1.8-1.8,3-2,5.6h-1.8A8.2,8.2,0,0,1,118.7,130.8Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.9,129.1h2.6c1.4,0,2.6.3,2.6,1.7a1.6,1.6,0,0,1-.8,1.5h0a1.6,1.6,0,0,1,1.2,1.6c0,1.5-1.3,2.1-2.8,2.1h-2.8Zm2.5,2.7c.6,0,.9-.3.9-.7s-.3-.6-.9-.6h-.6v1.3Zm.2,2.8c.7,0,1-.3,1-.8s-.3-.7-1-.7h-.8v1.5Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.3,132.6a3.5,3.5,0,0,1,3.4-3.7,2.7,2.7,0,0,1,2.1,1l-.9,1.1a1.8,1.8,0,0,0-1.2-.5c-.8,0-1.5.8-1.5,2s.6,2,1.5,2a1.9,1.9,0,0,0,1.3-.5l.9,1.1a2.9,2.9,0,0,1-2.3,1A3.2,3.2,0,0,1,128.3,132.6Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 82.7,
    y: 103.7,
    width: 27,
    height: 19.78,
    style: {
      fill: "var(--ca-primary-color-lightest, #96e3fa)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.2,132.4a4,4,0,0,0-1.9,5.7l-1-1.7a4,4,0,0,0-5-1.8,4,4,0,0,0-1.9,5.7l-1-1.7a4,4,0,0,0-5-1.8,4,4,0,0,0-1.9,5.7L133.9,128a3.9,3.9,0,1,0-6.8,4l15.6,26.3a.4.4,0,0,1-.6.6l-5.9-3.5a4,4,0,0,0-5.4,1.1,3.9,3.9,0,0,0,1.1,5.4,99.7,99.7,0,0,0,11.8,6.6c6.5,2.9,13.9,6.5,20.1,4.5,10.2-3.4,10.6-9.8,10.6-13a44.9,44.9,0,0,0-5.4-19.4l-3.7-6.3A4.1,4.1,0,0,0,160.2,132.4Z",
    style: {
      fill: "#fff",
      stroke: "var(--ca-primary-color-light, #00a2d4)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.1,
    y: 109.6,
    width: 26.6,
    height: 5.63,
    style: {
      fill: "var(--ca-primary-color-lightest, #96e3fa)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.7,
    y: 103.7,
    width: 27,
    height: 19.78,
    style: {
      fill: "var(--ca-primary-color-lightest, #96e3fa)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.1,
    y: 109.6,
    width: 26.6,
    height: 5.63,
    style: {
      fill: "var(--ca-primary-color-lightest, #96e3fa)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.7,
    y: 103.7,
    width: 27,
    height: 19.78,
    style: {
      fill: "var(--ca-primary-color-lightest, #96e3fa)"
    }
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSmsFeatureAblaufgrafikDesktopStep3Rgb);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/sms-feature-ablaufgrafik-desktop-step3-rgb.bfa74d3e42001c1a7c1cc6372afc8b12.svg";